<template>
  <div v-if="isRadio">
    <div v-for="(lang, i) in $i18n.availableLanguages" :key="`Lang${i}`" class="mb-2">
      <base-radio v-model="locale" :value="lang.value">{{ lang.label }}</base-radio>
    </div>
  </div>

  <div v-else-if="isDropdown">
    <base-dropdown-2 context="secondary" size="sm">
      <template>
        <div class="flex items-center space-x-1.5">
          <base-icon icon="globe" class="text-lg hidden h-8 lg:block text-primary-dark" />
          <span class="lg:block hidden">{{ translateLabel() }}</span>
          <span class="lg:hidden">{{ locale.toUpperCase() }}</span>
        </div>
      </template>
      <template #body>
        <div v-for="lang in availableLanguages" :key="lang">
          <div
            class="py-2 px-6 text-sm hover:bg-secondary-light cursor-pointer"
            @click="locale = lang.value"
          >
            {{ lang.label }}
          </div>
        </div>
      </template>
    </base-dropdown-2>
  </div>

  <base-select
    v-else
    v-model="locale"
    :options="availableLanguages"
    :optionType="{id: 'value', label: 'label'}"
    :searchable="false"
    :theme="$attrs.theme"
    :size="$attrs.size"
    bg="white"
  />
</template>

<script>
import {BaseRadio, BaseSelect, BaseDropdown2, BaseIcon} from '@/components/base'

export default {
  data() {
    return {
      locale: this.$i18n.locale,
      availableLanguages: this.$i18n.availableLanguages,
    }
  },
  watch: {
    locale: 'changeLocale',
  },
  methods: {
    changeLocale() {
      this.$store.dispatch('app/changeLocale', this.locale)
    },
    translateLabel() {
      const lang = this.availableLanguages.find(language => language.value === this.locale)
      return lang.label
    },
  },
  components: {
    BaseRadio,
    BaseSelect,
    BaseDropdown2,
    BaseIcon,
  },
  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
    isDropdown: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
